import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import isoWeek from 'dayjs/plugin/isoWeek'
import { rootActions } from '@app-store/slices'
import store from '@app-store/store'

dayjs.extend(utc)
dayjs.extend(isoWeek)

export const callAvailableSlotsEndpoint = (
    hostCompanyId,
    guestCompanyId,
    guestIds,
    hostIds,
    isMeetingHubEvent,
    week
) => {
    if (guestIds && hostIds) {
        const payload: any = {
            hostCompanyId,
            hostIds,
            guestIds,
            guestCompanyId
        }
        if (isMeetingHubEvent) {
            payload.userStartDate = (
                week === 0 ? dayjs().utc().add(1, 'days') : dayjs().utc().startOf('isoWeek').add(week, 'weeks')
            ).format('YYYY-MM-DD[T]00:00:00')
            payload.userEndDate = dayjs().utc().endOf('isoWeek').add(week, 'weeks').format('YYYY-MM-DD[T]23:59:59')
        }
        store.dispatch(rootActions.meetings.getAvailableSlots.onRequest(payload))
    }
}
